
export const getSelection = (items, selected) => {

    let retVal = [];
    if (items.length > 0 && selected.length > 0) {
        const firstSelectedIndex = 0;
        const lastSelectedIndex = (selected.length-1);

        const firstSelectedId = selected[firstSelectedIndex].id;
        const lastSelectedId = selected[lastSelectedIndex].id;

        const firstItemIndex = items.findIndex(i => i.id === firstSelectedId);
        const lastItemIndex  = items.findIndex(i => i.id === lastSelectedId);

        // get all items between selection
        let sliceParams = [firstItemIndex, lastItemIndex]
        if (firstItemIndex > lastItemIndex) {
            sliceParams = [lastItemIndex, firstItemIndex];
        }

        retVal = items.slice(...sliceParams);
    }

    return retVal;
}
